// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Quotes: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 55.7"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M8.5 17.4c-.4 0-.8-.2-1.1-.4L3 12.6c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l3.1 3.1 7.1-10.4c.5-.7 1.4-.9 2.1-.4.7.5.9 1.4.4 2.1L9.7 16.8c-.3.4-.7.6-1.1.7 0-.1-.1-.1-.1-.1zm45.6-5.9H21.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h32.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5zM8.5 35.2c-.4 0-.8-.2-1.1-.4L3 30.4c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l3.1 3.1L15.3 21c.5-.7 1.4-.9 2.1-.4.7.5.9 1.4.4 2.1L9.7 34.5c-.3.4-.7.6-1.1.7 0-.1-.1 0-.1 0zm45.6-6H21.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h32.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5zM8.5 52.9c-.4 0-.8-.2-1.1-.4L3 48.1c-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0l3.2 3 7.1-10.4c.5-.7 1.4-.9 2.1-.4.7.5.9 1.4.4 2.1L9.7 52.2c-.3.4-.7.6-1.1.7h-.1zm45.6-6H21.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h32.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5z"/></svg>;
};

export default React.memo(Quotes);
